import authReducer from './authReducer'
import announcementReducer from './announcementReducer'
import {combineReducers} from 'redux'
import {firestoreReducer} from 'redux-firestore'
import {firebaseReducer} from 'react-redux-firebase'
import { raiseQueryReducer} from './raiseQueryReducer'
const rootReducer = combineReducers({
    auth : authReducer,
    announcement : announcementReducer,
    query : raiseQueryReducer,
    firestore : firestoreReducer,
    firebase : firebaseReducer       
});

export default rootReducer;